import {Option, Select} from "@material-tailwind/react";
import React from "react";
import {KeyboardArrowDown} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {CustomTypography} from "./CustomTypography";
import {Skeleton} from "./Skeleton";
import {SelectOptionInterface} from "../../services/interface/catalogs/select-option-interface";

export interface CustomSelectProps {
    value?: any;
    setValue?: any;
    label?: string;
    labelFixel?: boolean;
    className?: string;
    classNameContainer?: string;
    loading?: boolean;
    mandatory?: boolean;
    options?: SelectOptionInterface[];
    error?: string;
    disabled?: boolean;
    fontSize?: string;
    testId?: string;
    onChange?: any;
}

const CustomSelect = ({
                          value,
                          setValue,
                          labelFixel,
                          label,
                          options,
                          loading,
                          mandatory,
                          className,
                          classNameContainer,
                          error,
                          disabled,
                          fontSize,
                          testId,
                          onChange,
                      }: CustomSelectProps) => {
    const labelView = ((value?.idSelect !== -1 && !value?.idDataStr) || (value?.idDataStr !== '-1' && !value?.idSelect) || labelFixel || (labelFixel === undefined && label))
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [isMenuOpen] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const handleChange = (e: any) => {
        const typeRequestAux = options?.find(item => item?.idSelect?.toString() === e)
        if (onChange) onChange(e);
        if (setValue) setValue(typeRequestAux ? typeRequestAux : null);
    };

    return (
        <>
            {loading ? (
                <div className={'custom-select grid w-full'}>
                    <Skeleton className={'min-h-[40px] max-h-[40px]'}/>
                </div>
            ) : (
                <div className={`custom-select grid w-full bg-white ${classNameContainer}`}>
                    {labelView &&
                        <div className={'label labelCustom'}>
                        <span
                            className={
                                `${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] ${label ? 'bg-white' : ''} ml-[18px] px-1 rounded-[5px] ${mandatory ? 'mt-[-2px]' : ''}`
                            }
                        >
                            {label}
                            {mandatory && <span className={'text-danger ml-[2px]'}>*</span>}
                        </span>
                        </div>
                    }
                    <div className={`${labelView ? 'select' : 'relative'}`}> {/* Agrega un contenedor relativo */}
                        <Select
                            data-testid={testId}
                            placeholder='select'
                            disabled={disabled}
                            onFocus={() => {
                                setFocus(true)
                            }}
                            onBlur={() => {
                                setFocus(false)
                            }}
                            className={`styleInput text-input z-50 !border
                            ${error ? '!border-danger text-danger placeholder:text-danger' : 
                            disabled ? '!border-colorDisabled' : '!border-inputBorder'} 
                            flex min-h-[40px] max-h-[40px] rounded-[4px] shadow-lg shadow-gray-900/5 ring-1 
                            ring-transparent placeholder:text-gray-500 focus:!border-primary disabled:bg-white
                            ${className}`}
                            containerProps={{className: "min-w-[52px]"}}
                            labelProps={{
                                className: 'hidden',
                            }}
                            menuProps={{
                                className: 'max-h-[200px]'
                            }}
                            onChange={handleChange}
                            selected={() => {
                                if (value !== null) {
                                    return (
                                        <div
                                            className={`pr-[30px] max-h-[25px] line-clamp-1 text-custom-input 
                                            ${error ? 'text-danger' : value?.idSelect === -1 || value?.idDataStr === '-1' ? 'text-inputBorder' : 'text-input'}`}
                                            style={{fontSize: fontSize ? fontSize : ''}}
                                        >
                                            {error ? error : value?.descriptionData ? t(value.descriptionData) : t('select')}
                                        </div>
                                    )
                                }
                            }}
                        >
                            {options ?
                                options.map((item, index) => (
                                    <Option className={'z-50'} key={item.idSelect !== undefined ? item.idSelect : item.idDataStr !== undefined ? item.idDataStr : index}
                                            data-id={item.idSelect ? item.idSelect : item.idDataStr}
                                            value={item.idSelect ? item.idSelect.toString() : ''}>
                                        {item.descriptionData ? t(item.descriptionData) : item.description}
                                    </Option>
                                )) :
                                <Option>{t('no-records')}</Option>
                            }
                        </Select>
                        <div className="absolute w-full justify-end inset-y-0 left-0 flex pointer-events-none">
                        <span
                            className={`flex mt-[12px] items-center h-[18px] w-6 mr-[6px] bg-white transition-transform ${
                                isMenuOpen ? "rotate-180" : ""
                            }`}>
                            <KeyboardArrowDown
                                className={`${disabled ? 'text-colorDisabled' : focus ? 'text-primary' : 'text-inputBorder'}`}/>
                        </span>
                        </div>
                        {error && <CustomTypography variant="small" style={{color: 'red'}}
                                                    className="static mt-[1px] font-normal ml-1 text-[10px]"
                                                    text={t('obligatory-field')}/>}
                    </div>
                </div>
            )}
        </>
    )
}

export default CustomSelect
